import React from "react";
import { Divider } from "../../BP2Components";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import InfoLineImageWidgetSettings from "../WidgetsSettings/WebWidgets/InfoLineImageWeb/InfoLineImageWidgetSettingsModal";
import IntlMessages from "@util/IntlMessages";

const InfoLineImageWidget = ({ value, role }) => {
   return (
      <>
         <Widget
            styleName="gx-m-0"
            bgColor={value.backgroundColourHex}
            title={<IntlMessages id="web.infoLineImageWidget" />}
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  <SettingsModal
                     widgetId={value.id}
                     widgetName={value.name}
                     icon="setting"
                     deleteIcon="true"
                     children={<InfoLineImageWidgetSettings value={value} />}
                  />
               )
            }
         >
            <strong>
               <IntlMessages id="settings.imageWidgetTitleTranslationKey" /> :
            </strong>{" "}
            {value.imageWidgetTitleTranslationKey}
            <Divider />
            <strong>
               <IntlMessages id="settings.widgetKey" /> :
            </strong>{" "}
            {value.widgetKey}
            <Divider />
            <strong>
               {" "}
               <IntlMessages id="settings.images" />
            </strong>
            <ul>
               {value.images.map((image) => (
                  <li>{image.fileName}</li>
               ))}
            </ul>
         </Widget>
      </>
   );
};

export default InfoLineImageWidget;
